import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form } from "antd";
import { useRef } from "react";
import { FormContentBlockerFieldGeneralCompose, FormContentBlockerFieldTechnicalCompose, FormContentBlockerFieldVisualCompose, FormContentBlockerFieldTemplateCheck } from ".";
import { useI18n } from "../../../contexts";
import { FormValueDifferFromTemplateNotice, FormUntranslatedTemplateNotice, FormValueDifferFromTemplateResetButtonWithConfirm, FORM_DIFFER_RESET_BUTTON_WITH_CONFIRM_CUSTOM_EVENT, FormFieldTemplateSuccessorDeletionCheck } from "..";
const FormContentBlocker = (param)=>{
    let { technicalProps, visualProps } = param;
    const { __ } = useI18n();
    const ref = useRef();
    const refResetTemplateButton = useRef();
    return /*#__PURE__*/ _jsxs("div", {
        ref: ref,
        children: [
            /*#__PURE__*/ _jsx(FormValueDifferFromTemplateNotice, {
                containerRef: ref,
                resetButton: refResetTemplateButton,
                resetButtonEvent: FORM_DIFFER_RESET_BUTTON_WITH_CONFIRM_CUSTOM_EVENT,
                form: "blocker"
            }),
            /*#__PURE__*/ _jsx(FormUntranslatedTemplateNotice, {
                form: "blocker"
            }),
            /*#__PURE__*/ _jsx(FormContentBlockerFieldGeneralCompose, {}),
            /*#__PURE__*/ _jsx(FormContentBlockerFieldTechnicalCompose, {
                ...technicalProps
            }),
            /*#__PURE__*/ _jsx(FormContentBlockerFieldVisualCompose, {
                ...visualProps
            }),
            /*#__PURE__*/ _jsx(FormFieldTemplateSuccessorDeletionCheck, {
                type: "blocker"
            }),
            /*#__PURE__*/ _jsxs(Form.Item, {
                className: "rcb-antd-form-sticky-submit",
                colon: false,
                labelAlign: "left",
                label: /*#__PURE__*/ _jsx(FormValueDifferFromTemplateResetButtonWithConfirm, {
                    anchorRef: refResetTemplateButton
                }),
                children: [
                    /*#__PURE__*/ _jsx(FormContentBlockerFieldTemplateCheck, {}),
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            textAlign: "center",
                            margin: "10px 0"
                        },
                        children: /*#__PURE__*/ _jsx("input", {
                            type: "submit",
                            className: "button button-primary",
                            value: __("Save")
                        })
                    })
                ]
            })
        ]
    });
};
export { FormContentBlocker };
